import { render, staticRenderFns } from "./aliPay.vue?vue&type=template&id=e4893bdc&scoped=true&"
import script from "./aliPay.vue?vue&type=script&lang=js&"
export * from "./aliPay.vue?vue&type=script&lang=js&"
import style0 from "./aliPay.vue?vue&type=style&index=0&id=e4893bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4893bdc",
  null
  
)

export default component.exports